var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("Spinner")
        : _vm.getBoletosError
        ? _c(
            "div",
            { staticClass: "notification-content" },
            [
              _c("Message", {
                attrs: {
                  message: _vm.getBoletosError.message,
                  icon: _vm.getBoletosError.icon,
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "transactions-view" }, [
            _c(
              "div",
              { staticClass: "header-container" },
              [
                _c("span", [_vm._v("Status do Boleto")]),
                _c(
                  "b-dropdown",
                  {
                    attrs: {
                      id: "filtro-status",
                      position: "is-bottom-right",
                      "append-to-body": "",
                      "close-on-click": true,
                      "mobile-modal": false,
                      "aria-role": "list",
                    },
                    on: {
                      "active-change": function ($event) {
                        return _vm.updateBoletosHistory($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "trigger",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                staticClass: "status-filter-button",
                                attrs: {
                                  rounded: "",
                                  type: "is-button-secondary",
                                },
                              },
                              [
                                _c("span", { staticClass: "icon is-small" }, [
                                  _c("i", { staticClass: "fas fa-filter" }),
                                ]),
                                _c("span", [_vm._v("Filtrar")]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.selectedStatus,
                      callback: function ($$v) {
                        _vm.selectedStatus = $$v
                      },
                      expression: "selectedStatus",
                    },
                  },
                  _vm._l(_vm.statusFilter, function (value, status) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: status,
                        attrs: {
                          id: value,
                          value: value,
                          "aria-role": "listitem",
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(status))])]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.getBoletosMessage
              ? _c(
                  "div",
                  { staticClass: "notification-content" },
                  [
                    _c("Message", {
                      attrs: {
                        message: _vm.getBoletosMessage.message,
                        icon: _vm.getBoletosMessage.icon,
                        "as-card": false,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "transactions-container" },
                  [
                    _vm._l(_vm.boletos, function (boleto) {
                      return _c("SingleBoleto", {
                        key: boleto._id,
                        attrs: {
                          "current-user-is-client": _vm.currentUserIsClient,
                          "is-extended": false,
                          boleto: boleto,
                        },
                      })
                    }),
                    !_vm.isLoading && _vm.numberOfDocuments > _vm.boletos.length
                      ? _c("creditu-pagination", {
                          attrs: {
                            "page-number": _vm.pageNumber,
                            size: "is-small",
                            "documents-per-page": _vm.documentsPerPage,
                            "items-name": "Boletos",
                            total: _vm.numberOfDocuments,
                            "range-before": 1,
                            "range-after": 1,
                            "documents-per-page-options": [10, 20, 50],
                          },
                          on: {
                            "update:pageNumber": function ($event) {
                              _vm.pageNumber = $event
                            },
                            "update:page-number": function ($event) {
                              _vm.pageNumber = $event
                            },
                            "update:documentsPerPage": function ($event) {
                              _vm.documentsPerPage = $event
                            },
                            "update:documents-per-page": function ($event) {
                              _vm.documentsPerPage = $event
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }